export const colorSchemes = {
  default: {
    gnb: {
      background: 'navigationBackgroundPrimaryDark',
      color: 'textNeutralLightest',
      dividerColor: 'navigationBorderPrimaryLight',
      ctaButton: {
        background: {
          active: 'buttonBackgroundPrimaryBase',
          disabled: 'pureNavy800',
        },
      },
      item: {
        color: 'rgba(255, 255, 255, 0.5)',
        fontWeight: '500',
        hover: {
          backgroundColor: '#2D374A',
          color: 'rgba(255, 255, 255, 0.5)',
        },
        active: {
          backgroundColor: '#3C475C',
          color: 'white',
        },
      },
      logoColor: '#fff',
      sectionNameColor: 'textNeutralUltraLight',
    },
  },
  light: {
    gnb: {
      background: 'white',
      color: 'black',
      dividerColor: 'navigationBorderNeutralBase',
      ctaButton: {
        background: {
          active: 'buttonBackgroundPrimaryBase',
          disabled: 'buttonBackgroundNeutralBase',
        },
      },
      item: {
        color: 'textNeutralBase',
        fontWeight: '400',
        iconColor: 'textNeutralBase',
        hover: {
          backgroundColor: 'pureBlue25',
          color: 'iconEmphasisBase',
        },
        active: {
          backgroundColor: 'pureBlue50',
          color: 'iconEmphasisBase',
        },
      },
      logoColor: 'darkGray300',
      sectionNameColor: 'white',
    },
  },
};
